// extracted by mini-css-extract-plugin
module.exports = {"inform":"information_inform__Vx1A6","img__wrapper":"information_img__wrapper__3uARi","img":"information_img__3T4B4","title":"information_title__HQ6k0"};